export const SET_CATEGORY_STREAM_UNSUBSCRIBER = 'SET_CATEGORY_STREAM_UNSUBSCRIBER';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';


// WEBPACK FOOTER //
// ./src/store/categories/mutations.js